import App from './es/views/App'
import Home from './es/views/Home'
import ModelReport from './es/views/ModelReport'
import planOptimizer from './es/views/planOptimizer'
import planSimulator from './es/views/planSimulator'
import SimulationDetails from './es/views/SimulationDetails'
import Documents from './es/views/Documents'
import WhatIfScenario from './es/views/WhatIfScenario'
import BudgetSimulator from './es/views/BudgetSimulator'
import BudgetSimulationDetails from './es/views/BudgetSimulationDetails'
import adminUsers from './es/views/adminUsers'
import adminClients from './es/views/adminClients'
import adminReferenceModels from './es/views/adminReferenceModels'
import adminAdHocModels from './es/views/adminAdHocModels'
import manageCustomModels from './es/views/manageCustomModels'
import manageEkrm from './es/views/manageEkrm'
import modelComposer from './es/views/modelComposer'
import automaticModels from './es/views/automaticModels'
import manageUserModels from './es/views/manageUserModels'
import learningCenter from './es/views/learningCenter'
import stats from './es/views/stats'
import adminTools from './es/views/adminTools'
import adminPendingPlans from './es/views/adminPendingPlans'
import adminAIReviews from './es/views/adminAIReviews'
import adminErrorLogs from './es/views/adminErrorLogs'
import adminNews from './es/views/adminNews'
import adminCountries from './es/views/adminCountries'
import InsertMap from './es/views/InsertMap'
import playground from './es/views/playground'
import DataUpload from './es/views/DataUpload'
import DataCheck from './es/views/DataCheck'
import ModelingProcess from './es/views/ModelingProcess'
import SharedPlan from './es/views/SharedPlan'
import SharedModelReport from './es/views/SharedModelReport'
import ExportData from './es/views/ExportData'

// Components translations
import components from './es/components/index'
import AI from './es/components/AI'
import ekrm from './es/components/ekrm'
import simulationDetails from './es/components/simulationDetails'
import budgetSimulator from './es/components/budgetSimulator'
import userData from './es/components/userData'
import dataCheck from './es/components/dataCheck'

export default {
  views: {
    App,
    Home,
    ModelReport,
    planOptimizer,
    BudgetSimulator,
    BudgetSimulationDetails,
    planSimulator,
    SimulationDetails,
    Documents,
    WhatIfScenario,
    adminUsers,
    adminClients,
    adminReferenceModels,
    adminAdHocModels,
    manageCustomModels,
    manageEkrm,
    modelComposer,
    automaticModels,
    manageUserModels,
    learningCenter,
    stats,
    adminTools,
    adminPendingPlans,
    adminAIReviews,
    adminErrorLogs,
    adminNews,
    adminCountries,
    InsertMap,
    playground,
    DataUpload,
    DataCheck,
    ModelingProcess,
    SharedPlan,
    SharedModelReport,
    ExportData
  },
  components: {
    ...components,
    AI,
    ekrm,
    simulationDetails,
    budgetSimulator,
    userData,
    dataCheck
  }
}
